import { AuthCheckFailedDialog, TokenRefreshOverlay } from '@onesource/components';
import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { Suspense } from 'react';

import { SHOW_DEV_TOOLS } from '../config';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <Suspense>
      <TokenRefreshOverlay />
      <AuthCheckFailedDialog />
      <Outlet />
      {SHOW_DEV_TOOLS && <TanStackRouterDevtools />}
    </Suspense>
  ),
});
